import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControlledColorFilter } from '@vlabs/monokit/shared/ui/controlled-color-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { useTranslation } from 'react-i18next';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';

function ShoesFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useWorkspaceFilters();
  const selectedOptions = filters.shoes_apparent_colors ?? [];
  const options = EVENT_ENUMS.LOWER_BODY.SHOES.APPARENT_COLOR.raw as Option[];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedOptions.length === 0}
      onClickReset={() => updateFilters({ shoes_apparent_colors: undefined })}
      ref={ref}
    >
      <ControlledColorFilter
        label={t('events:shoes_colors')}
        onChange={(colors) => updateFilters({
          shoes_apparent_colors: colors.length > 0 ? colors : undefined,
        })}
        options={options}
        value={selectedOptions}
      />
    </PopoverWithButton>
  );
}

const ShoesFilterPopoverWithRef = forwardRef(ShoesFilterPopover);
export { ShoesFilterPopoverWithRef as ShoesFilterPopover };
